import {useTranslation} from "react-i18next"
import AddProjectBtn from "../../components/add-project-btn/AddProjectBtn"
import openRedFolderIcon from "../../assets/icon/open-red-folder.svg"
import {useStProjectsContext} from "../../reactContext/contextCustomHooks/useStProjectsContext"

export default function StProjectsHeader() {
    const {t} = useTranslation()
    const {stProjectsContext} = useStProjectsContext()
    let title = stProjectsContext.tab.replace("-", " ")
    title = title[0].toUpperCase() + title.slice(1)
    if (title === "My projects") {title = "My subtitling projects"}
    return (
        <>
        <div className="SECTION ST-PROJECTS-HEADER">
            <AddProjectBtn type={"st"}/>
            <h2><img src={openRedFolderIcon} alt=""/>{t(`${title}`)}</h2>
            {title === "My subtitling projects" ?
                <><p>{t("Pick up where you left off.")}</p></> :
                title === "Shared projects" ?
                <><p>{t("Contribute to your team's projects.")}</p></> :
                <><p>{t("Restore your deleted projects.")}</p></>
            }
        </div>
        </>
    )
}